import type { OffersTranslation } from './types';

export const offersUr: OffersTranslation = {
  title: 'آپ کو پیش کی گئی',
  intro:
    'قبول کریں تو چیٹ آپ کی ہو جائے گی۔ انکار کریں یا وقت ختم ہو جائے تو یہ اگلے شخص کو جائے گی۔',
  timeLeft: '{{time}} باقی',
  timeLeftLabel: 'قبول کرنے کے لیے باقی وقت: {{time}}',
  timeUp: 'وقت ختم',
  round: '3 میں سے پیشکش {{round}}',
  accept: 'قبول کریں',
  acceptName: '{{name}} کے ساتھ چیٹ قبول کریں',
  decline: 'انکار کریں',
  declineName: '{{name}} کے ساتھ چیٹ سے انکار کریں',
  accepted: '{{name}} کے ساتھ چیٹ اب آپ کی ہے۔',
  declined: 'آپ نے {{name}} کے ساتھ چیٹ سے انکار کیا۔ یہ اگلے شخص کو جائے گی۔',
  closed: 'یہ پیشکش اب کھلی نہیں ہے۔',
  offeredTo: '{{name}} کو پیش کی گئی · {{time}}',
  offeredToYou: 'آپ کو پیش کی گئی · {{time}}',
  declineDialog: {
    title: 'اس چیٹ سے انکار کریں',
    description:
      'یہ اگلے اس شخص کو پیش کی جائے گی جو اسے لے سکتا ہے۔ آپ کی وجہ محفوظ رہتی ہے تاکہ ٹیم لیڈ کام بانٹ سکیں۔',
    reason: 'آپ انکار کیوں کر رہے ہیں؟',
    reasonMissing: 'کوئی وجہ چنیں۔',
    reasons: {
      at_capacity: 'ابھی میرے پاس بہت چیٹس ہیں',
      not_my_area: 'یہ میرا شعبہ نہیں',
      going_offline: 'میں آف لائن جا رہا ہوں',
      other: 'کچھ اور',
    },
    goingOfflineHint: 'آپ کا اسٹیٹس "دور" ہو جائے گا، تاکہ آپ کو مزید چیٹس پیش نہ ہوں۔',
    note: 'نوٹ',
    noteHint: 'اختیاری۔ آپ کے ٹیم لیڈ اسے پڑھ سکتے ہیں۔',
    submit: 'چیٹ سے انکار کریں',
  },
  load: '{{max}} میں سے {{open}} چیٹس',
  loadNoLimit: '{{open}} کھلی چیٹس',
  team: {
    summaryQueue: 'نئی چیٹس ٹیم کی قطار میں انتظار کرتی ہیں، کوئی بھی لے سکتا ہے۔',
    summaryOffer: 'نئی چیٹس ایک وقت میں ایک شخص کو پیش کی جاتی ہیں، ہر ایک کو {{seconds}} سیکنڈ۔',
    edit: 'چیٹس کیسے پہنچتی ہیں',
    editName: '{{team}} میں چیٹس پہنچنے کا طریقہ بدلیں',
    title: '{{team}} میں چیٹس کیسے پہنچتی ہیں',
    description: 'چنیں کہ اس ٹیم کو سونپی گئی چیٹ اس کے لوگوں تک کیسے پہنچے۔',
    mode: 'جب ٹیم کے پاس کوئی چیٹ آئے',
    modes: {
      queue: 'سب دیکھیں',
      queueHint: 'یہ ٹیم کی قطار میں انتظار کرتی ہے اور ٹیم کا کوئی بھی شخص اسے لیتا ہے۔',
      offer: 'ایک وقت میں ایک شخص کو پیش کریں',
      offerHint:
        'یہ آن لائن سب سے موزوں شخص کو پیش کی جاتی ہے: جو اپنی حد سے کم ہو، گاہک کی زبان بولتا ہو اور جس کے پاس سب سے کم کھلی چیٹس ہوں۔ اگر وہ انکار کریں یا وقت پر جواب نہ دیں تو اگلے شخص کو پیش کی جاتی ہے۔ تین لوگوں کے بعد یہ قطار میں انتظار کرتی ہے۔ اس دوران کوئی بھی اسے لے سکتا ہے۔',
    },
    timeout: 'قبول کرنے کے لیے سیکنڈ',
    timeoutHint: '15 سے 600 سیکنڈ۔',
    timeoutInvalid: '15 سے 600 تک سیکنڈ کی تعداد لکھیں۔',
    save: 'محفوظ کریں',
    saved: '{{team}} میں چیٹس پہنچنے کا طریقہ محفوظ ہو گیا۔',
  },
  people: {
    title: 'زبانیں اور حدیں',
    description:
      'چیٹس پہلے ان لوگوں کو پیش کی جاتی ہیں جو گاہک کی زبان بولتے ہیں، اور کبھی اسے نہیں جو اپنی حد پر ہو۔',
    none: 'کوئی زبان درج نہیں',
    noLimit: 'کوئی حد نہیں',
    limit: 'زیادہ سے زیادہ {{max}} کھلی چیٹس',
    edit: 'ترمیم',
    editName: '{{name}} کی زبانوں اور حد میں ترمیم کریں',
    dialogTitle: '{{name}} کی زبانیں اور حد',
    languages: 'وہ کن زبانوں میں جواب دیتے ہیں',
    max: 'ایک ساتھ زیادہ سے زیادہ کھلی چیٹس',
    maxHint: '1 سے 50 تک۔ کوئی حد نہ رکھنی ہو تو خالی چھوڑیں۔',
    maxInvalid: '1 سے 50 تک کوئی عدد لکھیں، یا خالی چھوڑیں۔',
    save: 'محفوظ کریں',
    saved: '{{name}} کی زبانیں اور حد محفوظ ہو گئیں۔',
    loading: 'زبانیں اور حدیں لوڈ ہو رہی ہیں',
  },
};
